import { useState, useMemo } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { galleryItems, galleryCategories } from "@/data/gallery";
import { X } from "lucide-react";
import Reveal from "@/components/Reveal";

const Galeria = () => {
  const [active, setActive] = useState("Todos");
  const [openIdx, setOpenIdx] = useState(null);

  const filtered = useMemo(
    () => (active === "Todos" ? galleryItems : galleryItems.filter((i) => i.category === active)),
    [active]
  );

  return (
    <div data-testid="galeria-page" className="pb-24">
      <section className="container-luxe py-12">
        <Reveal>
          <p className="overline mb-4">— Portfolio</p>
          <h1 className="font-serif text-6xl sm:text-7xl lg:text-8xl font-light leading-[0.95] text-ink max-w-3xl">
            Trabalhos &{" "}
            <span className="italic gold-text">transformações</span>
          </h1>
          <p className="mt-6 text-ink/65 max-w-xl text-lg">
            Uma seleção do meu trabalho real. Mais novidades diariamente no Instagram{" "}
            <a
              href="https://www.instagram.com/tamaraalveshairstylist/"
              target="_blank"
              rel="noreferrer"
              className="text-gold hover:underline"
            >
              @tamaraalveshairstylist
            </a>.
          </p>
        </Reveal>
      </section>

      <section className="container-luxe">
        <div className="flex flex-wrap gap-2 mb-10" data-testid="gallery-filters">
          {galleryCategories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActive(cat)}
              data-testid={`gallery-filter-${cat.replace(/\s|&/g, "-").toLowerCase()}`}
              className={`px-5 py-2 text-xs uppercase tracking-[0.2em] transition-all duration-300 border ${
                active === cat
                  ? "bg-gold-bright border-gold text-ink shadow-[0_0_15px_rgba(255,215,0,0.35)]"
                  : "border-ink/15 text-ink/70 hover:border-gold hover:text-gold"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <Reveal stagger className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 lg:gap-4">
          {filtered.map((item, idx) => (
            <button
              key={item.id}
              onClick={() => setOpenIdx(idx)}
              data-testid={`gallery-item-${item.id}`}
              className="group relative overflow-hidden aspect-[3/4] bg-beige-light transition-all duration-700 hover:shadow-[0_30px_60px_-15px_rgba(218,165,32,0.4)] hover:-translate-y-2"
            >
              <img
                src={item.src}
                alt={item.alt}
                className="w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-end p-5">
                <p className="overline !text-gold">{item.category}</p>
                <p className="text-beige font-serif text-lg mt-1 leading-tight">{item.alt}</p>
              </div>
            </button>
          ))}
        </Reveal>
      </section>

      <Dialog open={openIdx !== null} onOpenChange={(o) => !o && setOpenIdx(null)}>
        <DialogContent
          data-testid="gallery-lightbox"
          className="max-w-5xl bg-ink border-gold/30 p-0 overflow-hidden"
        >
          {openIdx !== null && filtered[openIdx] && (
            <div className="relative">
              <img
                src={filtered[openIdx].src}
                alt={filtered[openIdx].alt}
                className="w-full max-h-[85vh] object-contain"
              />
              <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-ink to-transparent p-6">
                <p className="overline !text-gold">{filtered[openIdx].category}</p>
                <p className="text-beige font-serif text-2xl mt-2">{filtered[openIdx].alt}</p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Galeria;
